import "core-js/modules/es.object.to-string.js";
import { queryDataSourcePage, dataSourceSave, dataSourceEdit, dataSourceTest, dataSourceDelete, dataSourceEnable, dataSourceDetail } from '@/api/form/formManageApi.js';
import { getFirstDictFixInfo } from '@/services/basicDataMgr.js';
export default {
  data: function data() {
    var _this = this;
    return {
      addDataSourceStatus: false,
      loading: false,
      sjklx: [],
      sjkqdl: [],
      sjkljc: [],
      form: {
        sjymc: '',
        //数据库名
        xsmc: '',
        //显示名称
        sjklx: undefined //数据库类型
      },
      columns: [{
        title: '数据库名',
        dataIndex: 'sjymc',
        align: 'center',
        width: '120px'
      }, {
        title: '显示名称',
        dataIndex: 'xsmc',
        align: 'center',
        width: '150px'
      }, {
        title: '链接地址',
        dataIndex: 'ljdz',
        align: 'center',
        width: '200px'
      }, {
        title: '用户名',
        dataIndex: 'yhm',
        align: 'center',
        width: '100px'
      }, {
        title: '数据库类型',
        dataIndex: 'sjklx',
        align: 'center',
        width: '150px'
      }, {
        title: '数据源描述',
        dataIndex: 'sjyms',
        align: 'center',
        width: '150px'
      }, {
        title: '链接状态',
        dataIndex: 'ljzt',
        align: 'center',
        width: '100px',
        scopedSlots: {
          customRender: 'ljzt'
        }
      }, {
        title: '启用状态',
        dataIndex: 'sxzt',
        align: 'center',
        width: '100px',
        scopedSlots: {
          customRender: 'sxzt'
        }
      }, {
        title: '创建人',
        dataIndex: 'cjr',
        align: 'center',
        width: 120
      }, {
        title: '创建时间',
        dataIndex: 'cjsj',
        align: 'center',
        width: 160
      }, {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: '120px',
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      tableData: [],
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 19
      },
      paginationTable: {
        total: 0,
        defaultPageSize: 10,
        showTotal: function showTotal(total) {
          return "\u5171 ".concat(total, " \u6761\u6570\u636E");
        },
        showSizeChanger: true,
        pageSizeOptions: ['10', '15', '20'],
        onShowSizeChange: function onShowSizeChange(current, pageSize) {
          return _this.pageSize = pageSize;
        }
      },
      addForm: {
        sjybm: '',
        sjymc: '',
        xsmc: '',
        sjklx: undefined,
        ljdz: '',
        yhm: '',
        mm: '',
        qdl: undefined,
        ljc: undefined,
        sjyms: ''
      },
      //新建数据源校验规则
      addFormRules: {
        sjymc: [{
          required: true,
          message: '请填写数据源名称',
          trigger: 'blur'
        }],
        xsmc: [{
          required: true,
          message: '请填写显示名称',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    fetch: function fetch(options) {
      var _this2 = this;
      var pagination = this.pagination,
        where = this.where,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      queryDataSourcePage(pager.current, pager.pageSize, this.form).then(function (res) {
        if (res.data.code == 200) {
          _this2.tableData = res.data.data;
          _.assign(pagination, {
            total: res.data.count,
            current: pager.current,
            pageSize: pager.pageSize
          });
          _.assign(where, pager.where);
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    /*
     * 表格改变事件
     */
    onChange: function onChange(pagination) {
      this.fetch({
        current: pagination.current,
        pageSize: pagination.pageSize,
        where: this.where
      });
    },
    delClick: function delClick(row) {
      var $confirm = this.$confirm,
        $message = this.$message,
        fetch = this.fetch;
      $confirm("确认删除吗?", "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        dataSourceDelete({
          sjybm: row.sjybm
        }).then(function (res) {
          if (res.data.code == 200) {
            $message.success('删除成功');
            fetch();
          }
        });
      }).catch(function () {});
    },
    editClick: function editClick(row) {
      this.addDataSourceStatus = true;
      _.assign(this.addForm, row);
    },
    statusChange: function statusChange(sjybm, sxzt) {
      var _this3 = this;
      var req = {
        sjybm: sjybm
      };
      if (sxzt === 1) {
        req.sxzt = 0;
        dataSourceEnable(req).then(function (res) {
          if (res.data.code == 200) {
            _this3.$message.success('停用成功');
            _this3.fetch();
          }
        });
      } else if (sxzt === 0) {
        req.sxzt = 1;
        dataSourceEnable(req).then(function (res) {
          if (res.data.code == 200) {
            _this3.$message.success('启用成功');
            _this3.fetch();
          }
        });
      }
    },
    addDataSource: function addDataSource() {
      this.addDataSourceStatus = true;
      this.$refs.addForm.resetFields(); //清除数据
    },
    // 新增数据源提交
    onFormSubmit: function onFormSubmit() {
      var _this4 = this;
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this4.loading = true;
          if (_this4.addForm.sjybm) {
            dataSourceEdit(_this4.addForm).then(function () {
              _this4.addDataSourceStatus = false;
              _this4.fetch();
              _this4.$message.success('编辑成功!');
            }).finally(function () {
              _this4.loading = false;
            });
          } else {
            dataSourceSave(_this4.addForm).then(function () {
              _this4.addDataSourceStatus = false;
              _this4.fetch();
              _this4.$message.success('保存成功!');
            }).finally(function () {
              _this4.loading = false;
            });
          }
        }
      });
    },
    // 新增数据源点击返回方法
    onFormCancel: function onFormCancel() {
      this.addDataSourceStatus = false; //隐藏
      this.$refs.addForm.resetFields(); //清除据
    },
    getDictSelect: function getDictSelect(categoryId) {
      var _this5 = this;
      //返回一级字典
      getFirstDictFixInfo(categoryId).then(function (res) {
        if (22 == categoryId) {
          _this5.sjkqdl = res.data.data;
        }
        if (23 == categoryId) {
          _this5.sjklx = res.data.data;
        }
        if (24 == categoryId) {
          _this5.sjkljc = res.data.data;
        }
      });
    },
    // 连接测试
    onTest: function onTest() {
      var _this6 = this;
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this6.loading = true;
          dataSourceTest(_this6.addForm).then(function () {
            _this6.$message.success('连接成功！');
          }).finally(function () {
            _this6.loading = false;
          });
        }
      });
    }
  },
  mounted: function mounted() {
    this.fetch();
    this.getDictSelect(22);
    this.getDictSelect(23);
    this.getDictSelect(24);
  }
};